// extracted by mini-css-extract-plugin
export default {"error":"Error_error__G+oIr","icon":"Error_icon__RSnOn"};